module.exports = __webpack_public_path__ + "static/quartier_I-4f6baed6eaf98907de948d3769ba315f.png";